import config from '../config'
import { GET_BASE_INFO, FREQUENT_SPACE_INFO, GET_SHARE_LINK, GET_SHARE_USER_INFO, FIND_USER_DEPARTMENTS, FILE_LIST } from '../config/api'
import ajax from '../utils/ajax'
import { setLanguageType } from '@/utils/i18n'
import customStyle from '../utils/customStyle'
import { loadJweixinIfNeeded, setDocumentTitle } from '../utils/common'
import WxAppletBoot from './wxAppletBoot'
import OpenBootstrap from './openBootstrap'

export default () => {
  // 公开页面无需初始化用户信息，避免触发登录跳转。
  if (/^\/(?:h5\/)?navigateToMiniApp\/?$/.test(location.pathname)) {
    document.title = '加载中'
    return Promise.resolve()
  }

  // log的强制开关
  // let forceLog = false
  let forceLog = true // 暂时开启
  if (!forceLog && process.env.NODE_ENV === 'production') {
    // eslint-disable-next-line no-global-assign
    console = console || {}
    console.log = function () {}
  }

  if (!window.Intl) {
    require.ensure([
      '../utils/polyfill'
    ], (require) => {
      require('../utils/polyfill')
    })
  }

  customStyle()

  // TODO: open selector
  // const isOpen = /scenario=open/.test(window.location.search)
  // if (isOpen) {
  //   const openOrigin = window.location.search.match(/origin=([^&]+)/)
  //   if (openOrigin) config.openOrigin = openOrigin[1]
  // }

  const openConfigKeys = ['origin', 'userName', 'productName', 'theme', 'confirmBtnText', 'selectFileMax', 'previewUserToken', 'uploadFileMax']
  const openConfig = {}
  openConfigKeys.forEach(key => {
    let matchValue = window.location.search.match(new RegExp(`${key}=([^&]+)`))
    if (matchValue) openConfig[key] = decodeURIComponent(matchValue[1])
  })
  config.openConfig = openConfig
  // console.info(config)

  let wxAppletBoot = new WxAppletBoot()
  if (wxAppletBoot.isFromWx()) {
    wxAppletBoot.loadJs()
    wxAppletBoot.customStyle()
    return wxAppletBoot.bootApplet()
  }

  if (OpenBootstrap.isFromOpenPlatform()) {
    let openBoot = new OpenBootstrap()
    return openBoot.bootstrap()
  }

  // todo 下面的代码以后有时间可以单独剥离出来，做成和WxAppletBoot一样的模式，可以考虑通过工厂模式处理
  // h5.fangcloud.com/share/xxx || v2.fangcloud.com/h5/share/xxx
  const pathNameArr = location.pathname.split('/').filter(item => item)

  let isPromotion = false
  // 活动页
  if (pathNameArr.includes('promotion')) {
    isPromotion = true
  }

  let isIntroduce = false // 转介绍h5
  if (pathNameArr.includes('introduce')) {
    isIntroduce = true
  }

  const isShare = pathNameArr[0] === 'h5' ? pathNameArr[1] === 'share' : pathNameArr[0] === 'share'
  const share_link_token = isShare ? (pathNameArr[0] === 'h5' ? pathNameArr[2] : pathNameArr[1]) : ''
  const accept_all_errors = isShare || isPromotion || isIntroduce

  let promiseTask = new Promise(resolve => {
    // wechat 分享只需要通过ua就能判断是否需要load jweixin-sdk
    loadJweixinIfNeeded()
    // get account info and csrf_token
    // 第一次只能发起一个请求 要不然 csrf_token 会有问题
    ajax({
      url: GET_BASE_INFO,
      accept_all_errors
    }).then((result = {}) => {
      if (result && !result.enterprise_info) {
        result.enterprise_info = {}
      }
      const {
        enterprise_info: { is_from_wechat_enterprise } = {},
        user_guide_settings: { user_guide_h5_sync, user_guide_h5_upload, user_guide_h5_logout } = {},
        is_h5_show_user_guide = false
      } = result

      config.doclib_application_url = result.doclib_application_url
      config.csrf_token = result.csrf_token
      config.user_info = result.user_info
      config.university_account_status = result.university_account_status
      config.enterprise_info = result.enterprise_info
      config.enterprise_info_base = result.enterprise_info || {}
      config.unread_messages_count = result.unread_messages_count
      config.product_name = result.product_name
      config.is_from_wechat_enterprise = is_from_wechat_enterprise // 记录是否来自于企业微信
      config.enterpirse_wxwork_guide_sync = is_from_wechat_enterprise && !user_guide_h5_sync // 企业微信引导下载客户端
      config.enterpirse_wxwork_guide_upload = is_from_wechat_enterprise && !user_guide_h5_upload // 企业微信引导上传文件
      config.enterpirse_wxwork_guide_logout = is_from_wechat_enterprise && !user_guide_h5_logout // 微信引导登出，然后用其他账号登录
      // console.log(config.enterpirse_wxwork_guide_logout)
      config.enterpirse_is_h5_show_user_guide = is_h5_show_user_guide // 企业微信引导下载客户端 后端开关 控制开启与关闭
      config.sensitive_control_strategy = result.enterprise_info.sensitive_control_strategy ? result.enterprise_info.sensitive_control_strategy : {} // 含有敏感词的文件的按钮权限
      config.isSensitiveInfoDetectEnabled = result.enterprise_info.is_sensitive_info_detect_enabled ? result.enterprise_info.is_sensitive_info_detect_enabled : false
      config.workflowUrl = 'https://ark.fangcloud.net'
      config.is2023FreePlan = result.enterprise_info.plan_id === 28
      // set language type
      setLanguageType(result.enterprise_info ? result.enterprise_info.language_type : 'enterprise')

      if (result.user_info && result.user_info.is_admin_of_enterprise && result.enterprise_info && result.enterprise_info.qiyu_info_submit === 1) {
        setdeptAndFolderInfo()
      }

      setViewConfig(result)
      // if (result.custom_color) {
      //   customStyle(result.custom_color)
      // }

      setDocumentTitle(config.product_name || '')

      if (result.base_url) {
        config.imageUrl = result.base_url.replace(/\/$/, '')
        config.loginUrl = config.imageUrl + '/sso/login'
        config.logoutUrl = config.imageUrl + '/sso/logout'
        config.registerUrl = config.imageUrl + '/auth/register'
      }

      // wxwork 分享需要is_from_wechat_enterprise字段来判断是否需要load jweixin-sdk
      loadJweixinIfNeeded()

      // 该接口会重定向到登录页，当是活动页时绕过该接口
      // 分享场景也绕过该接口
      if (isIntroduce || isShare) {
        resolve()
      } else {
        ajax({
          url: FREQUENT_SPACE_INFO,
          accept_all_errors
        }).then(result => {
          config.frequent_space = result
          resolve()
        })
      }

      // resolve()
    })
  })

  function setdeptAndFolderInfo () {
    ajax({
      url: FIND_USER_DEPARTMENTS
    }).then(res => {
      if (res && res.success) {
        config.wellcomeDeptId = res.departments.id
        ajax({
          url: `${FILE_LIST}/0?department_id=${config.wellcomeDeptId}`
        }).then(res => {
          if (res && res.children) {
            config.wellcomeFolderInfo = res.children[0]
          }
        })
      }
    })
  }

  // 专有云功能裁剪，需要兼容公有云逻辑
  function setViewConfig (result) {
    const { enterprise_info = {}, env_config } = result
    if (env_config && env_config.env === 'profession') {
      // 取交集
      config.viewConfig.isYiqixieEnabled = env_config.config.is_yiqixie_enabled
      config.viewConfig.isWpsPreviewEnabled = env_config.config.is_wps_preview_enabled
      config.viewConfig.isVirusScanEnabled = env_config.config.is_virus_scan_enabled
      config.viewConfig.isH5HideShareLinkDownload = env_config.config.is_h5_hide_share_link_download
      config.viewConfig.isComplainEnabled = env_config.config.is_show_help_chat // 使用帮助中心字段控制
      config.viewConfig.isDlpEnabled = env_config.config.is_dlp_enabled && enterprise_info.is_huatu_dlp
      config.viewConfig.is_changxie_edit_enabled = env_config.config.is_changxie_edit_enabled
    } else {
      // 只取白名单
      config.viewConfig.isDlpEnabled = enterprise_info && enterprise_info.is_huatu_dlp
      config.viewConfig.isFileManagerEnabled = enterprise_info && enterprise_info.is_file_manager_enabled
      config.viewConfig.is_changxie_edit_enabled = env_config.config.is_changxie_edit_enabled
    }
  }

  return promiseTask.then(() => {
    if (isShare) {
      return ajax({
        url: `/apps/share_links/check_multi_share/${share_link_token}`,
        data: {
          h5: 1
        },
        accept_all_errors: true
      }).then(checkData => {
        if (!(checkData && checkData.success && checkData.item_type === 'vfolder')) {
          return ajax({
            url: `${GET_SHARE_LINK}/${share_link_token}`,
            accept_all_errors: true
          }).then(result => {
            // 重定向到 免费域名
            if (result.errors && result.redirect_domain) {
              window.location.href = result.redirect_domain + document.location.pathname
            }

            config.externalShareResponse = result
            return ajax({
              url: `${GET_SHARE_USER_INFO}?share_link_token=${share_link_token}&scenario=share`,
              accept_all_errors: true
            }).then(result => {
              if (result && result.success) {
                config.product_id = result.product_id
                config.resource_id = result.resource_id
                config.open_app_url = result.open_app_url
                config.is_custom_product = result.is_custom_product
                Object.assign(config, result)
              }
            })
          })
        } else {
          return ajax({
            url: `${GET_SHARE_USER_INFO}?share_link_token=${share_link_token}&scenario=share`,
            accept_all_errors: true
          }).then(result => {
            if (result && result.success) {
              config.product_id = result.product_id
              config.resource_id = result.resource_id
              config.open_app_url = result.open_app_url
              config.is_custom_product = result.is_custom_product
              Object.assign(config, result)
            }
          })
        }
      })
    } else {
      return new Promise((resolve) => resolve())
    }
  })
}
